import React from "react";
import { WebpTermsofuseBg } from "../assets";
import Footer from "../components/Footer";
import { addAnimation } from "../utils/addAnimation";

export default function Terms() {
  return (
    <>
      {" "}
      <section className="about__hero">
        <img
          loading="lazy"
          className="about__hero__img"
          src={WebpTermsofuseBg}
          alt=" At AFF, we pioneer evocative aromas and tastes that inspire and endure. As an ambitious trailblazer in Asia, we envision a world where every Scent tells a story, and every Flavor is a journey AdvancedFF, a leader in global Flavors & Fragrances, offers cutting-edge aromatic solutions, bespoke scents, and innovative flavor creations. With a commitment to excellence, our natural extracts, culinary aromas, and custom fragrance formulations redefine sensory experiences. Explore our diverse range of gourmet essences, aroma compounds, and unique fragrances crafted with expertise. From scent marketing to personalized aromatics, our top-rated flavor and fragrance design elevate culinary sensations. AdvancedFF sets the standard in fragrance trends, delivering premium scents, bespoke flavoring, and unparalleled fragrance diversity. Experience the artistry of AdvancedFF, where advanced technology meets olfactory mastery for a world-class sensory journey ,AdvancedFF, a leader in global Flavors & Fragrances, offers cutting-edge aromatic solutions, bespoke scents, and innovative flavor creations. With a commitment to excellence, our natural extracts, culinary aromas, and custom fragrance formulations redefine sensory experiences. Explore our diverse range of gourmet essences, aroma compounds, and unique fragrances crafted with expertise. From scent marketing to personalized aromatics, our top-rated flavor and fragrance design elevate culinary sensations. AdvancedFF sets the standard in fragrance trends, delivering premium scents, bespoke flavoring, and unparalleled fragrance diversity. Experience the artistry of AdvancedFF, where advanced technology meets olfactory mastery for a world-class sensory journey,advancedffwebsite aff  aff website   advancedff advancedff.com advancedff advancedff advancedgg advancedff advancedgg affwebsite  Advanced Flavors & Fragrances Pte. Ltd. Advanced Flavors & Fragrances Pte. Ltd. Advanced Flavors and  Flavors & Fragrances Pte. Ltd. advnacedff   flavour flavour singapore advancedff-Image Containg Buildings"
        />
        <div className="about__hero__content">
          <div className="about__hero__content__heading">
            Terms & Conditions for your Purchase
          </div>
        </div>
      </section>
      <section className="natural__flavor__container">
        <div className="natural__flavor__container__wraper">
          <div className="natural__flavor__container__wraper__contant">
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Introduction")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              By proceeding to checkout and ticking the box to agree to these
              Terms & Conditions, you ("the Customer") agree to the terms
              outlined below with Advanced Flavors & Fragrances Pte. Ltd. ("the
              Company"), registered in Singapore. These terms apply to all items
              added to your cart and govern the agreement between you and the
              Company until the completion of your purchase.
              <br />
              <br />
            </div>
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Acknowledgment")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              The Customer acknowledges that adding items to the cart and
              proceeding to checkout does not constitute a final agreement or an
              irrevocable commitment to sell by the Company.
              <br />
              <br />
              Prices displayed prior to checkout are tentative and subject to
              change without notice. The Company reserves the right to adjust
              prices, including but not limited to errors in pricing, until the
              moment of sale confirmation. Product availability is not
              guaranteed. The Company reserves the right to cancel any order due
              to stock unavailability or any unforeseen inability to fulfill the
              order.
              <br />
              <br />
            </div>
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Order Confirmation and Cancellation")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              {addAnimation(
                `The sale is considered binding only upon the Company's issuance of an order confirmation via email or another written form. Until such confirmation is provided, the Company reserves the right to refuse or cancel any order for any reason, including but not limited to pricing errors, product discontinuation, and inventory issues.
                `
              )}
              <br />
              <br />
              The Customer agrees that the Company may cancel an order and
              provide a full refund, without further liability or obligation,
              should any issue arise that prevents the completion of the sale as
              initially agreed.
              <br />
              <br />
            </div>

            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Liability and Indemnification")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              {addAnimation(
                `The Company disclaims all liability for any loss or damage incurred as a result of order cancellation, pricing adjustments, or product unavailability.
                `
              )}
              <br />
              <br />
              The Customer agrees to indemnify and hold harmless the Company,
              its directors, officers, employees, and agents from and against
              any claims, liabilities, damages, losses, and expenses, including
              without limitation reasonable legal and accounting fees, arising
              out of or in any way connected with your breach of these Terms &
              Conditions.
              <br />
              <br />
            </div>
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Changes to Terms & Conditions")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              {addAnimation(
                `The Company reserves the right to update or modify these Terms & Conditions at any time without prior notice. By ticking the acceptance box at checkout, the Customer agrees to be bound by such modifications or updates.                `
              )}
              <br />
              <br />
            </div>
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Governing Law")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              {addAnimation(
                `These Terms & Conditions and any disputes arising out of or related to them will be governed by and construed in accordance with the laws of Singapore, without giving effect to any choice or conflict of law provision or rule.
                `
              )}
              <br />
              <br />
            </div>
            <div className="natural__flavor__container__wraper__contant__heading">
              {addAnimation("Contact Information")}
            </div>
            <div className="natural__flavor__container__wraper__contant__heading__sub">
              {addAnimation(
                `For any inquiries regarding these Terms & Conditions, please contact us at `
              )}
              <a className="termcontactus" href="mailto::sales@advancedff.com">
                Sales@advancedff.com{" "}
              </a>{" "}
              Or
              <a className="termcontactustwo" href="tel: +65 6909 8635">
                {" "}
                +65 6909 8635.
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
